module.exports = __webpack_public_path__ + "assets/img/title-17e440c4.png";